import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="mt-8 py-6 border-t border-gray-200 bg-white/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          {/* Copyright */}
          <div className="text-sm text-gray-600">
            {t('footer.copyright', { year: currentYear })}
          </div>

          {/* Legal Links */}
          <div className="flex flex-wrap gap-4 md:gap-6 text-sm justify-center items-center">
            <Link
              to="/privacy"
              className="text-gray-600 hover:text-blue-600 transition"
            >
              {t('footer.privacy')}
            </Link>
            <Link
              to="/terms"
              className="text-gray-600 hover:text-blue-600 transition"
            >
              {t('footer.terms')}
            </Link>
            <Link
              to="/data-deletion"
              className="text-gray-600 hover:text-blue-600 transition"
            >
              {t('footer.dataDeletion')}
            </Link>
            <LanguageSwitcher variant="compact" />
          </div>

          {/* Social/Contact */}
          <div className="text-sm text-gray-600">
            <a
              href="mailto:support@socialocto.com"
              className="hover:text-blue-600 transition"
            >
              support@socialocto.com
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
